import { Component, inject } from '@angular/core';
import { WaitingScreenComponent } from '../../waiting-screen/waiting-screen.component';
import {ActivatedRoute, RouterOutlet} from '@angular/router';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
    selector: 'app-inscription-layout',
    templateUrl: './inscription-layout.component.html',
    styleUrls: ['./inscription-layout.component.scss'],
    imports: [RouterOutlet, WaitingScreenComponent]
})
export class InscriptionLayoutComponent {
  private readonly route = inject(ActivatedRoute);


  showInscription: boolean;

  constructor() {
    const route = this.route;

    route.data.pipe(takeUntilDestroyed()).subscribe(data => {
      this.showInscription = data.showInscription;
    });
  }

}
